'use client';
import { ForwardedRef, forwardRef, memo, useMemo } from 'react';
import { View } from 'react-native';

import { BoxProps } from './Box.types';
import { BOX_COMPONENTS } from './Box.content';
import { absoluteFillProps, centerContentProps } from './Box.constants';

function Box({
  variant = 'default',
  absoluteFill,
  centerContent,
  ...rest
}: BoxProps, ref: ForwardedRef<View>) {
  const Component = BOX_COMPONENTS[variant];
  const extraProps = useMemo(() => {
    const props = {};

    if (absoluteFill) {
      Object.assign(props, absoluteFillProps);
    }

    if (centerContent) {
      Object.assign(props, centerContentProps);
    }

    return props;
  }, [centerContent, absoluteFill]);

  return <Component ref={ref} {...extraProps} {...rest} />;
}

export default memo(forwardRef(Box));
